module.exports = __webpack_public_path__ + "img/data2.82a34827.png";